import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const SalesOrder = () => {
  return (
    <PrintPreferenceTabs type="sales_order"></PrintPreferenceTabs>
  );
};
export default SalesOrder;


